{
  "endTime": "Heure de fin",
  "startTime": "Heure de début",
  "time": "Heure"
}
